import {
   StructuredSurvey,
   StructuredSurveyQuery,
   StructuredSurveyTemplate,
   StructuredSurveyTemplateQuery,
} from '@dreryk/egabinet-survey-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../translations';

type MedicalProfileTabLoaderRenderProps = {
   readonly template: StructuredSurveyTemplate;
   readonly structuredSurvey: StructuredSurvey | null;
};

type MedicalProfileTabLoaderProps = {
   readonly templateCode: string;
   readonly patientId: number;
   readonly children: (renderProps: MedicalProfileTabLoaderRenderProps) => JSX.Element;
};

// TODO DREGAB-29796: resolve the StructuredSurvey id for (patientId, templateCode) once the backend exposes the lookup query
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const resolveSurveyId = (patientId: number, templateCode: string): number | null => null;

export const MedicalProfileTabLoader = (props: MedicalProfileTabLoaderProps): JSX.Element => {
   const surveyId = resolveSurveyId(props.patientId, props.templateCode);

   const {
      data: fetchedTemplate,
      loading: templateLoading,
      error: templateError,
   } = useCqrsGet<StructuredSurveyTemplate>(() => {
      const query = new StructuredSurveyTemplateQuery();
      query.templateCode = props.templateCode;
      return query;
   });

   const { data: structuredSurvey, loading: surveyLoading, error: surveyError } = useCqrsGet<StructuredSurvey>(
      () => {
         const query = new StructuredSurveyQuery();
         query.id = surveyId!;
         return query;
      },
      { enabled: surveyId !== null }
   );

   if (templateLoading || surveyLoading) {
      return <LoaderSpinner />;
   }

   if (templateError || surveyError) {
      return (
         <Message
            testId={'medicalProfileFetchError'}
            type={MessageType.NEGATIVE}
            label={appointmentsTranslationKeys.medicalProfile.fetchError}
            displayIndicator
         />
      );
   }

   return props.children({
      template: fetchedTemplate,
      structuredSurvey: surveyId === null ? null : structuredSurvey ?? null,
   });
};
